import Type from './Type';
export function isIDiscourseExpected(discourse) {
    return discourse.type === Type.Expected;
}
export {
    isIDiscourseExpected as isIExpected
};
export default isIDiscourseExpected;    //# sourceMappingURL=isIExpected.js.map
